






















import { Component, Vue } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import SmallFooter from '@/components/SmallFooter.vue';
import SubjectsList from '@/components/SubjectsList.vue';
import SubjectsListMobile from '@/components/SubjectsListMobile.vue';
import { subjects, subjectsAndSub } from '../data/subjects';

@Component({
  components: {
    SmallFooter,
    SubjectsList,
    SubjectsListMobile,
  },
})
export default class Channels extends Vue {

  private showLogo: boolean = false;
  private subjectsMobileMenu: boolean | null = null;
  private showMainView: boolean = true;
  private displaySubjectsMobileMenu: string = 'none';

  private subjects: string[] = subjects;
  private subjectsAndSub: Map<string, string[]> = subjectsAndSub;

  public created() {
    window.addEventListener('scroll', this.handleScroll);
  }

  public destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  private handleScroll() {
    window.scrollY > 52 ? this.showLogo = true : this.showLogo = false;
  }

  private showSubjectsMobileMenu(show: boolean) {
    if (show) {
      this.subjectsMobileMenu = true;
      this.displaySubjectsMobileMenu = 'initial';
      // If subjects mobile menu is full size, hide main view to avoid scroll
      if (window.matchMedia('screen and (max-width: 475px)').matches) {
        setTimeout(() => {
          this.showMainView = false;
        }, 500);
      }
    } else {
      this.subjectsMobileMenu = false;
      this.showMainView = true;
      setTimeout(() => {
        this.displaySubjectsMobileMenu = 'none';
      }, 500);
    }
  }
}
